const getSiblings = function (elem) {
    var siblings = [];
    var sibling = elem.parentNode.firstChild;
    while (sibling) {
        if (sibling.nodeType === 1 && sibling !== elem) {
            siblings.push(sibling);
        }
        sibling = sibling.nextSibling;
    }
    return siblings;
};

const getClosest = function (elem, selector) {
    for (; elem && elem !== document; elem = elem.parentNode) {
        if (elem.matches(selector)) return elem;
    }
    return null;
};

const slugify = function(id) {
    return id 
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-') 		// Заменить пробелы на -
      .replace(/[^\w-]+/g, '') 	// Удалить все несловарные символы
      .replace(/--+/g, '-') 		// Заменить несколько - одним -
      .replace(/^-+/, '') 		// Обрезать - с начала текста
      .replace(/-+$/, '') 		// Обрезать - от конца текста
}

const createList = ({list, separator = ","}) =>{
    if(!list) return;
    return list.map((text, index) => {
        let sep;
        if(list.length !== index + 1){
            sep = separator;
        }
        return {text, sep}
    })
} 

const truncateString = (str, num) => {
    if (str.length <= num) {
      return str
    }
    return str.slice(0, num) + '...'
}

module.exports = { slugify, getSiblings, getClosest, createList, truncateString }